<template>
  <div>
    <v-toolbar absolute flat app theme--dark primary elevation-6>
      <logo />
    </v-toolbar>

    <header-image />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import Logo from '@/components/Logo';
import HeaderImage from '@/components/layout/HeaderImage';
import { config } from '@/utils/config';

// @vuese
// Uproszczony nagłówek strony
// @group MainLayout

export default {
  components: { Logo, HeaderImage }
};
</script>